import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Generate or get session ID for cart
export function getSessionId() {
  let sessionId = localStorage.getItem('cart_session_id');
  if (!sessionId) {
    sessionId = 'session_' + Math.random().toString(36).substr(2, 9) + Date.now();
    localStorage.setItem('cart_session_id', sessionId);
  }
  return sessionId;
}

// Format price in Swiss Francs
export function formatPrice(price) {
  return new Intl.NumberFormat('de-CH', {
    style: 'currency',
    currency: 'CHF'
  }).format(price);
}

// Get auth token
export function getAuthToken() {
  return localStorage.getItem('auth_token');
}

// Set auth token
export function setAuthToken(token) {
  localStorage.setItem('auth_token', token);
}

// Remove auth token
export function removeAuthToken() {
  localStorage.removeItem('auth_token');
}

// Get user from localStorage
export function getStoredUser() {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
}

// Set user in localStorage
export function setStoredUser(user) {
  localStorage.setItem('user', JSON.stringify(user));
}

// Remove user from localStorage
export function removeStoredUser() {
  localStorage.removeItem('user');
}

// API helper
export async function apiRequest(endpoint, options = {}) {
  const token = getAuthToken();
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const baseUrl = process.env.REACT_APP_BACKEND_URL || '';
  let response;
  const safeFetch = window.__safeFetch || window.fetch;
  try {
    response = await safeFetch(`${baseUrl}/api${endpoint}`, {
      ...options,
      headers
    });
  } catch (fetchError) {
    // Suppress postMessage/DataCloneError from browser internals
    if (fetchError?.message?.includes('postMessage') || fetchError?.message?.includes('DataCloneError') || fetchError?.name === 'DataCloneError') {
      throw new Error('Network error. Please try again.');
    }
    throw fetchError;
  }
  
  if (!response.ok) {
    let errorMessage = 'Request failed';
    try {
      const text = await response.text();
      try {
        const errorData = JSON.parse(text);
        errorMessage = errorData.detail || errorData.message || 'Request failed';
      } catch (e) {
        if (text) errorMessage = text;
      }
    } catch (e) {
      if (response.status === 400) {
        errorMessage = 'Bad request';
      } else if (response.status === 401) {
        errorMessage = 'Unauthorized';
      } else if (response.status === 404) {
        errorMessage = 'Not found';
      }
    }
    throw new Error(errorMessage);
  }
  
  return response.json();
}
